import { Link } from "react-router-dom"
import { TaskStatusIcon } from "../TaskChangeIcon"
import { TaskTypeIcon } from "../TaskTypeIcon"
import "react-loading-skeleton/dist/skeleton.css"
import { useEffect, useState } from "react"
import { useQuery } from "@apollo/client"
import { exceptionFromApolloError } from "../../util/apolloError"
import { GET_ACTIVITY_TASKCHANGES } from "../../api/QuadriApi"
import "react-loading-skeleton/dist/skeleton.css"
import { LoadingSkeleton, scrollElementId } from "../TasksDisplaySidebar"
import InfiniteScroll from "react-infinite-scroll-component"

interface TaskList {
  taskId: string
  taskName: string
  taskType: string
  changeType: string
}

export const TimelineTasksDisplaySidebar = (props: {
  nTasksTotal: number
  quadriProjectId: string
  activityType?: string
  activityIds?: number[]
  fetchCount?: number
}) => {
  const { nTasksTotal, quadriProjectId, activityType, activityIds, fetchCount } = props
  const [tasks, setTasks] = useState<TaskList[]>([])
  const { loading, error, data, fetchMore } = useQuery(GET_ACTIVITY_TASKCHANGES, {
    variables: {
      quadriProjectId,
      activityType,
      activityIds,
      fetchCount,
      fetchOffset: 0
    },
    errorPolicy: "all",
    skip: nTasksTotal === 0
  })
  if (error) throw exceptionFromApolloError(error)
  useEffect(() => {
    if (nTasksTotal === 0) {
      return setTasks([])
    }
    if (data) {
      const tasks = data?.getTaskChangesForAnActivity
      setTasks(tasks)
    }
  }, [data, props, nTasksTotal])

  const nTasksCurrent = tasks.length

  // Followup queries
  const fetchMoreData = async () => {
    console.log("Fetching more data")
    fetchMore({
      variables: { quadriProjectId, activityType, activityIds, fetchCount, fetchOffset: nTasksCurrent },
      updateQuery(previousQueryResult, options) {
        console.log("Updating query")
        const previousData = previousQueryResult.getTaskChangesForAnActivity
        const newTasks = options.fetchMoreResult?.getTaskChangesForAnActivity
        const newData = previousData.concat(newTasks)
        return { getTaskChangesForAnActivity: newData }
      }
    })
  }

  const hasMoreData = tasks.length < nTasksTotal

  if (loading) {
    return <LoadingSkeleton />
  }
  return (
    <ul className="list">
      <InfiniteScroll
        dataLength={tasks.length}
        next={fetchMoreData}
        hasMore={hasMoreData}
        loader={<LoadingSkeleton />}
        scrollableTarget={scrollElementId}
      >
        {tasks.map((task: any, index: any) => (
          <li className="list-item group border-bottom" key={index}>
            <Link to={`/tasks/${task.taskId}`}>
              <div className="group-items">
                <TaskStatusIcon taskStatus={getTaskStatus(task)} />
                <TaskTypeIcon type={task.taskType} />
                <span className="text two-lines-then-ellipsis">{task.taskName}</span>
              </div>
            </Link>
          </li>
        ))}
      </InfiniteScroll>
    </ul>
  )
}
const getTaskStatus = (task: TaskList) => task.changeType
